export default __webpack_public_path__ + "static/media/sticker-11.55796a21.png";